import * as React from 'react';
import { useSelector } from 'react-redux';

import { GallerySidebarContainer } from 'shared/containers/GallerySidebar';

import { trackFullscreenOpen } from './tracking';
import { useMortgageBanner } from './utils/useMortgageBanner';
import { EMediaType, Gallery, TMedia } from '../../components/GalleryRedesigned';
import THUMB_SRC from '../../components/offer_gallery/createMortgageFrame/img/thumb.svg';
import { FullScreenControlsContainer } from '../../components/offer_gallery/fotorama/full_screen_controls/container';
import { selectOffer } from '../../selectors';
import { NewbuildingBookedOverlayContainer } from '../NewbuildingBookedOverlayContainer';

interface IGalleryContainerProps {
  phoneButton?: boolean;
  favoritesButton?: boolean;
}

export const GalleryContainer: React.FC<IGalleryContainerProps> = ({ phoneButton = true, favoritesButton = true }) => {
  const { photos, videos } = useSelector(selectOffer);

  const mortgageBanner = useMortgageBanner(THUMB_SRC);

  const media: TMedia[] = React.useMemo(() => {
    const media: TMedia[] = [];

    if (videos) {
      media.push(...videos.map<TMedia>(v => ({ type: EMediaType.Video, src: v.url })));
    }

    if (photos) {
      const photoMedias = [...photos]
        .sort((a, b) => (a.isDefault === b.isDefault ? 0 : a.isDefault ? -1 : 1))
        .map<TMedia>(p => ({
          type: p.isLayout ? EMediaType.Layout : EMediaType.Photo,
          src: p.fullUrl,
          thumbnailSrc: p.thumbnailUrl,
        }));

      media.push(...photoMedias);
    }

    if (mortgageBanner) {
      media.push(mortgageBanner);
    }

    return media;
  }, [mortgageBanner, photos, videos]);

  return (
    <Gallery
      slotScrollerAfter={<NewbuildingBookedOverlayContainer />}
      slotFullscreenBefore={
        <FullScreenControlsContainer
          nextSliderCompat
          hideFavoritesButton={!favoritesButton}
          hidePhoneButton={!phoneButton}
        />
      }
      slotFullscreenSidebar={<GallerySidebarContainer />}
      media={media}
      onFullscreenOpen={trackFullscreenOpen}
    />
  );
};
